// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"283":"90bc1151","453":"9c3807b4"}[chunkId] + ".chunk.js";
};